import { render, staticRenderFns } from "./listClassic.vue?vue&type=template&id=28be584a&scoped=true"
import script from "./listClassic.vue?vue&type=script&lang=js"
export * from "./listClassic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28be584a",
  null
  
)

export default component.exports